import React from "react";
import PropTypes from "prop-types";
import { FormControl, InputLabel, TextField } from "@material-ui/core";
import { useStyles } from "./TextBoxStyles";

const TextBox = (props) => {
  const classes = useStyles();
  const {
    fieldLabel,
    handleChange,
    handleKeyDownChange,
    fullWidth,
    variant = "outlined",
    value,
    label,
    name,
    textBoxId,
    inputProps,
    error,
    helperText,
    type,
    placeholderText,
    readOnly,
    className,
    endAdornment,
    startAdornment,
    required = false,
    isDeliveryFee = false,
    isNegativeAllowed = true,
    InputProps,
    ...rest
  } = props;

  const handleInputChange = (e) => {
    if (isNegativeAllowed) {
      handleChange(e);
      return;
    }

    if (e?.target?.value < 0) {
      e.target.value = "";
      handleChange(e);
      return;
    }
    handleChange(e);
  };

  return (
    <>
      {fieldLabel && <div className={classes.fieldLabel}>{fieldLabel}</div>}
      <FormControl className={classes.root} variant={isDeliveryFee ? "filled" : variant}>
        <InputLabel htmlFor={textBoxId}></InputLabel>
        <TextField
          {...rest}
          className={`${className || ""} ${label ? "hasLabel " : ""}`}
          variant={isDeliveryFee ? "filled" : variant}
          fullWidth={fullWidth}
          id={textBoxId}
          placeholder={placeholderText}
          required={required}
          type={type}
          name={name}
          value={value}
          label={label}
          InputProps={{
            ...InputProps,
            className: classes.inputStyles,
            readOnly: readOnly,
            endAdornment: endAdornment,
            startAdornment: startAdornment,
          }}
          inputProps={inputProps}
          error={error}
          helperText={helperText}
          onKeyDown={handleKeyDownChange}
          onChange={handleInputChange}
        />
      </FormControl>
    </>
  );
};

TextBox.propTypes = {
  fieldLabel: PropTypes.string,
  handleChange: PropTypes.func,
  handleKeyDownChange: PropTypes.func,
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string,
  name: PropTypes.string,
  textBoxId: PropTypes.string,
  inputProps: PropTypes.object,
  error: PropTypes.bool,
  helperText: PropTypes.node,
  type: PropTypes.string,
  placeholderText: PropTypes.string,
  readOnly: PropTypes.bool,
  className: PropTypes.string,
  endAdornment: PropTypes.node,
  startAdornment: PropTypes.node,
  required: PropTypes.bool,
  isDeliveryFee: PropTypes.bool,
  isNegativeAllowed: PropTypes.bool,
  InputProps: PropTypes.object,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  onKeyUp: PropTypes.func,
  onClick: PropTypes.func,
};

export default React.memo(TextBox);